<template>
  <div>
    <slot :rules="mergedRulesString"></slot>
  </div>
</template>

<script>
import installedRules from '../validation/CustomRules';
export default {
  name: "ValidationWrapper.vue",
  props: {
    rules:{
      type: [String, Array],
      required: false,
      default: () => '',
    },
    name: {
      type: String,
      required: false
    },
  },
  computed: {
    validationRules() {
      if (!this.$store.hasModule('$_form_page')) return undefined;
      return this.$store.state[`$_form_page`]?.validationRules;
    },
    validationRulesForThis(){
      if (!this.validationRules) return undefined;
      if (!(this.name in this.validationRules)) return undefined;
      return this.validationRules[this.name];
    },
    mergedRules() {
      // If no custom rules were given.
      if (!this.frontEndRulesArray && this.serverValidationRulesAsArray)  {
        return this.cleanUpRulesArray(this.serverValidationRulesAsArray);
      }

      let mergedRules = [...this.frontEndRulesArray, ...this.serverValidationRulesAsArray];
      mergedRules = this.cleanUpRulesArray(mergedRules);
      return mergedRules;
    },
    frontEndRulesArray() {
      let frontEndRulesArray = [];
      // If custom rules were given in array format
      if(Array.isArray(this.rules)) {
        frontEndRulesArray = this.rules;
      }
      // If custom rules are given in string format
      else if (typeof this.rules === 'string' || this.rules instanceof String) {
        if (this.rules[this.rules.length-1] === '|') {
          frontEndRulesArray = this.rules.slice(0,-1).split('|');
        }
        else {
          frontEndRulesArray = this.rules.split('|');
        }
      }

      return frontEndRulesArray;
    },
    mergedRulesString() {
      return this.mergedRules.join('|');
    },
    serverValidationRulesAsArray() {
      let newRules = [];
      // If custom rules are given in string format
      if (typeof this.validationRulesForThis === 'string' || this.validationRulesForThis instanceof String) {
        newRules = this.validationRulesForThis.split('|');
      }
      else if (Array.isArray(this.validationRulesForThis)) {
        newRules = this.validationRulesForThis;
      }
      return newRules;
    },
  },
  methods: {
    cleanUpRulesArray(rulesArray) {
      let newRules = rulesArray.filter((rule) => !(typeof rule === 'object'));
      // Check against valid vee-validate rules and remove invalid vee-validate rules.
      newRules = newRules.filter((rule) => {
        return installedRules.includes(rule);
      });
      return newRules;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
